/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_ResumeInputs */

const en_timer_resume = /** @type {(inputs: Timer_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume timer`)
};

const de_timer_resume = /** @type {(inputs: Timer_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer fortsetzen`)
};

/**
* | output |
* | --- |
* | "Resume timer" |
*
* @param {Timer_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const timer_resume = /** @type {((inputs?: Timer_ResumeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_ResumeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_timer_resume(inputs)
	return en_timer_resume(inputs)
});